import { getCurrencyMinorUnitExponent } from './getCurrencyMinorUnitExponent';

/**
 * Converts a whole-unit amount to base units. 3-decimal currencies are truncated to a multiple of 10
 * (e.g. 1.2345 KWD -> 1230, not 1235), as payment processors such as Stripe only accept amounts with a last digit of 0.
 */
export function amountToBaseUnits(amount: number, currency: string): number {
	const exponent = getCurrencyMinorUnitExponent(currency);
	const baseUnits = Math.round(amount * 10 ** exponent);
	return exponent === 3 ? Math.floor(baseUnits / 10) * 10 : baseUnits;
}
